import { LoginScreen } from '@bala/ui';
import { api } from '../api';
import { useAuth } from '../auth';

/**
 * Connexion animateurs. Tout l'écran vient de `@bala/ui` : ne restent ici que
 * les deux phrases propres à cette application et le branchement au client.
 */
// Add this button component to your app to test Sentry's error tracking
function ErrorButton() {
  return (
    <button
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 99999,
        padding: '10px 16px',
        backgroundColor: '#dc2626',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      }}
      onClick={() => {
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  );
}

export function LoginPage() {
  const auth = useAuth();
  return (
    <>
      <ErrorButton />
      <LoginScreen
      subtitle="La gestion de la section, au même endroit."
      audienceNote="Application réservée aux animateurs de la section. Les parents utilisent Bala’App Parents."
      onSignIn={(email, password) => auth.signIn(email, password)}
      onVerifyCode={(challenge, code) => auth.verifyCode(challenge, code)}
      onForgot={async (email) => {
        await api.post<{ message: string }>('/auth/forgot', { email }, { queueOffline: false });
      }}
    />
  </>
  );
}
